<template>
  <div class="slider-card">
    <p
      v-if="title"
      class="headline"
    >
      {{ title }}
    </p>
    <div class="slider-card-wrapper">
      <div class="card">
        <img
          :src="storyImage"
          alt="developer"
          loading="lazy"
        />
        <div class="name-wrapper">
          <h2>{{ activeStory.name }}</h2>
          <img
            v-if="storyFlag()"
            :src="storyFlag()"
            class="flag"
            :alt="`${storyFlag} flag`"
          />
        </div>
        <p class="role">{{ activeStory.position }}</p>
        <p class="description">{{ activeStory.summary }}</p>
        <nuxt-link
          class="learn-more-btn"
          aria-label="Learn more"
          :to="`/stories/${activeStory.url}`"
          @click="trackEvent()"
        >
          Learn more
        </nuxt-link>
      </div>
      <div class="actions">
        <span
          class="arrow"
          @click="setActiveDeveloper('prev')"
        >
          <NuxtImg
            src="/images/story-page/arrow-left.svg"
            alt="arrow-left"
          />
        </span>
        <div class="indicators">
          <span
            v-for="(item, index) in otherStories"
            :key="index"
            :class="index === activeIndex && 'active'"
          ></span>
        </div>
        <span
          class="arrow"
          @click="setActiveDeveloper('next')"
        >
          <NuxtImg
            src="/images/story-page/arrow-right.svg"
            alt="arrow-right"
          />
        </span>
      </div>
    </div>

    <div
      v-if="!hideSocial"
      class="share-buttons-wrapper"
    >
      <Social :page-name="socialPageName" />
    </div>
  </div>
</template>

<script>
import Social from '~/components/Common/Social/Social.vue';
import cloudinaryImage from '~/utils/helpers/cloudinaryImage';
import slugRouteName from '~/mixins/slugRouteName';

export default {
  components: {
    Social,
  },
  mixins: [slugRouteName],
  props: {
    otherStories: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: 'More success stories',
    },
    hideSocial: {
      type: Boolean,
      default: false,
    },
    socialPageName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      activeIndex: 0,
    };
  },
  computed: {
    activeStory() {
      return this.otherStories[this.activeIndex];
    },
    storyImage() {
      return this.activeStory?.list_image
        ? cloudinaryImage({
            imagePath: this.activeStory.list_image,
            width: 400,
          })
        : null;
    },
  },
  methods: {
    setActiveDeveloper(type) {
      const length = this.otherStories.length;

      if (type === 'next') {
        this.activeIndex =
          this.activeIndex < length - 1 ? this.activeIndex + 1 : 0;
      } else if (type === 'prev') {
        this.activeIndex =
          this.activeIndex > 0 ? this.activeIndex - 1 : length - 1;
      }
    },
    storyFlag() {
      const activeStory = this.otherStories[this.activeIndex];

      return activeStory
        ? `/images/icons/flags/${activeStory?.member_country}.svg`
        : null;
    },
    trackEvent() {
      this.$analytics.track('CTA Clicked', {
        page_name: this.pageName,
        cta_name: 'Learn more',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import './SliderCard.scss';
</style>
